import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-promotionalsms',
  templateUrl: './promotionalsms.component.html',
  styleUrls: ['./promotionalsms.component.css']
})
export class PromotionalsmsComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {

    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    // this.displayedColumns = this.columnNames.map(x => x.id);


    this.getSMSTemplatePromotional();

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getSMSTemplatePromotional() {
    this.loginservice.getSMSTemplatePromotional()
      .subscribe(
        data => {
          this.dataresult = data['Data'];
        }, error => { alert('Network Error getSMSTemplatePromotional API'); });
  }



  search() {
    if (this.model['bill_no'] == '') {
      if (this.model['start_date'] == '' || this.model['end_date'] == '') {
        alert('Please Select Start & End Date & Bill No.');
        this._flashMessagesService.show('Please Select Start & End Date & Bill No.', { cssClass: 'alert-danger' });
        return true;
      }
    } else {
      if (this.model['start_date'] != '' && this.model['end_date'] == '') {
        alert('Please Select End Date');
        this._flashMessagesService.show('Please Select End Date', { cssClass: 'alert-danger' });
        return true;
      } else if (this.model['start_date'] == '' && this.model['end_date'] != '') {
        alert('Please Select Start Date');
        this._flashMessagesService.show('Please Select Start Date', { cssClass: 'alert-danger' });
        return true;
      }
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no']
    };
    this.getSMSTemplatePromotional()
  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/promotionalsms/promotionalsms.component.ts